<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
     <v-card class="box" v-if="this.transactions != ''">
     <v-data-table class="mytable elevation-1" dense  :headers="headers" :items="transactions" >
        <template v-slot:top>
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Transactions</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br>
        </template>
         <template v-slot:[`item.leaveapprovalstatus`]="{ item }">
              <v-btn  class="ma-2" tile outlined color="success" @click="showdetails(item.id)"> <v-icon left>mdi-arrow-right-bold-circle-outline</v-icon> Details</v-btn>
          </template>
         <template v-slot:[`item.edit`]="{ item }">
            <div>
              <v-avatar  size="25" class="edit-avatar">
                  <v-icon  class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
              </v-avatar>
            </div>
          </template>
     </v-data-table>
 </v-card> 
  <v-row justify="center" dense v-if="emp_approval_details!=''">
                <v-dialog v-model="dialog" persistent max-width="1500">
                    <v-card>
                        <v-col cols="12" sm="12" md="12">
                            <v-card class="box">
                                <v-toolbar flat dense class="toolbar">
                                    <v-toolbar-title>Leave Details</v-toolbar-title>
                                </v-toolbar>
                                <v-col cols="12" sm="12" md="12">
                                <v-simple-table dense class="elevation-1">
                                    <thead>
                                        <tr>
                                            <td>From Date</td>
                                            <td>To Date</td>
                                            <td>Application Date</td>
                                            <td>Number Of Days</td>
                                            <td>Number Of Hours</td>
                                            <td>Reason</td>
                                            <td>Is Load Adjustment Done</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{emp_approval_details[0].fromdate}}</td>
                                            <td>{{emp_approval_details[0].todate}}</td>
                                            <td>{{emp_approval_details[0].application_date}}</td>
                                            <td>{{emp_approval_details[0].numberofdays}}</td>
                                            <td>{{emp_approval_details[0].number_of_hours}}</td>
                                            <td>{{emp_approval_details[0].reason}}</td>
                                            <td>
                                                <span v-if="emp_approval_details[0].is_load_adjustment_done">YES</span>
                                                <span v-else>NO</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-simple-table dense class="elevation-1">
                                        <thead>
                                            <tr>
                                                <td>Alternate Arrangement Person Name</td>
                                                <td>Alternate Arrangement Person Contact Number</td>
                                                <td>Nature Of Work</td>
                                                <td>Place Of Work</td>
                                                <td>Email</td>
                                                <td>Mobile</td>
                                                <td>Medical Certificate / Other Document</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{emp_approval_details[0].alternate_arragement_person_name}}</td>
                                                <td>{{emp_approval_details[0].alternate_arragement_person_no}}</td>
                                                <td>{{emp_approval_details[0].nature_of_work}}</td>
                                                <td>{{emp_approval_details[0].place_of_work}}</td>
                                                <td>{{emp_approval_details[0].email}}</td>
                                                <td>{{emp_approval_details[0].contact_phone_number}}</td>
                                                <td>
                                                     <span v-if="emp_approval_details[0].certificate_file_name != 'NA'">
                                                    <a class="p-2" :href="aws_path+emp_approval_details[0].filepath+emp_approval_details[0].filename" target="blank">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                                            </template>
                                                            <span>
                                                                View Certificate / Other Document File!!!
                                                            </span>
                                                        </v-tooltip>
                                                    </a>
                                                     </span>
                                                     <span v-else>
                                                        {{emp_approval_details[0].certificate_file_name}}
                                                     </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-data-table :headers="headers1" :items="emp_approval_details[0].emp_approval" class="mytable elevation-1" dense>
                                    </v-data-table>
                                 </v-col>
                            </v-card>
                        </v-col>
                         <v-row justify="center" dense>
                             <v-btn class="button" @click="dialog = false">Close</v-btn>
                         </v-row>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,dialog:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      title:"",
      description:"",
       headers1 : [
            { text: "Sr. No", value: "srno" , sortable: false, },
        { text: "Authority", value: "authority" , sortable: false, },
        { text: "Authority Name", value: "authority_name" , sortable: false, },
        { text: "Date Of Application", value: "application_push_date" , sortable: false, },
        { text: "Date Of Approval", value: "application_action_date" , sortable: false, },
        { text: "Status", value: "status" , sortable: false, },
        { text: "Remark", value: "remark" , sortable: false, },
    ],
      headers:[
      { text: "Sr No", value: "count" },
      { text: "Leave Type", value: "leavetype" },
      { text: "Application Date", value: "application_date" },
      { text: "From Date", value: "fromdate" },
      { text: "To Date", value: "todate" },
      { text: "Days", value: "numberofdays" },
      { text: "Hours", value: "number_of_hours" },
      { text: "Reason", value: "reason" },
      { text: "Status", value: "leaveApprovalStatus" },
      { text: "Status", value: "leaveapprovalstatus" },
      { text: "Edit", value: "edit" },
    //  { text: "Pending From", value: "leavetype" },
      ],
      transactions:[],emp_approval_details:[]
  }),
   methods: {
        showdetails(emp_leave_transaction_id){
                this.dialog = true
                const formData = {
                    emp_leave_transaction_id:emp_leave_transaction_id
                }
                axios
                    .post("/LeaveManagement/getEmployeeLeaveDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                           this.emp_approval_details = res.data.emp_transaction_list
                           this.aws_path = res.data.aws_path
                        }
                    })
                    .catch((error) => {
                         this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                       
                    });
            },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
     onLoad() {
    axios
    .get("/LeaveManagement/applyLeave")
    .then((res) => {
        if (res.data.flag == "Yes") {
          this.transactions=res.data.transactions
        } 
        else {
        this.showSnackbar("#b71c1c", "Wrong information");   
        }
    })
    .catch((error) => {
        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
    })
    .finally(() => {
        // 'use strict';
    });
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    input[type="text"] {
        width: 100%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    .select {
        width: 100%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    input[type="date"] {
        width: 50%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
     tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .table-head-background {
        background-color: #fcc96f;
        color: #fff;
        font-weight: 700;
    }
    .tc-title {
        background-image: linear-gradient(-90deg, #fcc96f, #fcb63c);
        color: #fff;
        font-weight: 700;
        margin: 0px !important;
        padding: 0px !important;
    }
    .text-left {
        font-size: 14px;
        font-weight: bold;
    }
    .text {
        color: blue;
        font-weight: 600;
        font-size: 14px;
    }
     .card-container {
        overflow-x: hidden;
        overflow: hidden;
    }

</style>